<template>
  <div
    v-if="group"
    :key="id"
  >
    <img
      v-if="group.cover"
      class="cover"
      :src="group.cover"
    >
    <div class="row">
      <h2>{{ group.name }}</h2>
      <div class="spacer" />
      <div class="buttons">
        <router-link
          v-if="membership && membership.status === 'active'"
          :to="{name: 'chat_group', params: {id: $route.params.id}}"
          class="btn btn-primary btn-sm"
        >
          Chat
        </router-link>
        <router-link
          v-if="membership && membership.is_admin"
          :to="{name: 'edit_group', params: {id: $route.params.id}}"
          class="btn btn-primary btn-sm"
        >
          Edit
        </router-link>
        <router-link
          v-if="membership && membership.is_admin"
          :to="{name: 'group_members', params: {id: $route.params.id}}"
          class="btn btn-primary btn-sm"
        >
          Members
        </router-link>
        <join-group-button
          class="btn-sm"
          :group="group.id"
        />
        <a
          v-if="membership && membership.is_admin"
          href="#"
          class="btn btn-light btn-sm"
          @click.prevent="handleDelete"
        >
          Delete
        </a>
      </div>
    </div>
    <p>{{ group.short_description }}</p>

    <listing-loader
      page="group"
      :group="group.id"
      :membership="membership && membership.status == 'active' ? true : false"
    />
  </div>
  <div v-else>
    Loading...
  </div>
</template>

<script>
import JoinGroupButton from '../../components/JoinGroupButton.vue';
import ListingLoader from '@/components/ListingLoader.vue';

export default {
  name: 'GroupDetail',
  components: {
    JoinGroupButton,
    ListingLoader,
  },
  data() {
    return {
      group: null,
    };
  },
  computed: {
    id() { return parseInt(this.$route.params.id, 10); },
    membership() { return this.userGroups.find(g => g.id === this.id); },
  },
  watch: {
    id() {
      this.fetchGroup();
    },
  },
  async mounted() {
    await this.fetchGroup();
  },
  methods: {
    async fetchGroup() {
      const response = await this.api({ url: `groups/${this.id}` });
      if (response.ok) {
        this.group = response.body;
      } else {
        await this.$store.dispatch('fetchUserGroups');
        this.$router.push({ name: 'all_groups' });
      }
    },
    async handleDelete() {
      if (window.confirm(`Delete group: ${this.group.name}? There is NO UNDO`)) {
        const response = await this.api({
          url: `groups/${this.id}`,
          method: 'DELETE',
        });
        if (response.ok) {
          this.$router.push({ name: 'all_groups' });
        } else {
          alert('Failed to delete group', response);
        }
      }
    },
  },
};
</script>

<style scoped>
h2 {
  white-space: nowrap;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row {
  flex-wrap: wrap;
}
.cover {
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  background-position: center;
}
</style>
